// extracted by mini-css-extract-plugin
export default {"dividerContainer":"OurCenter_dividerContainer__lUi6r","dividerLine":"OurCenter_dividerLine__76FdP","dividerText":"OurCenter_dividerText__mxxTk"};